<template>
  <div class="wholeContext">
    <app-header :transDataSet="transDate"></app-header>
    <div class="appContext withWidget">
      <tracking-progress :transDataSet="transDate"></tracking-progress>
      <div class="join container">
        <div class="notification">
          <span class="imgWrap"><img src="../../assets/images/thanq_logo.png" /></span>
          <p class="nameSpace"><b>{{overlap}}님 환영합니다!</b></p>
          <p>회원가입이 완료되었습니다.</p>
          <p>땡큐와 함께 쉽고 편리하게 건강을 관리하세요!</p>
        </div>
      </div>
      <div class="btnWrap visible">
        <button class="" type="button" @click="nextMain()">회원가입 완료</button>
      </div>
    </div>
    <add-popup v-if="checkPopup"
               :popupSet="popupSet"/>
  </div>
</template>

<script>
import AppHeader from '../../components/AppHeader'
import AddPopup from '@/components/AddPopup'
import TrackingProgress from '../../components/TrackingProgress'
import { mapGetters, mapMutations, mapState } from 'vuex'

export default {
  data () {
    return {
      popupSet: {
        title: '',
        modalImg: 'alert_cn.svg',
        content: '',
        confirmBtnText: '확인',
        count: 'single',
        nextLink: '',
        closeType: 'close'
      },
      transDate: {
        headerName: '회원가입',
        progressNum: '100%',
        chapterNum: 3,
        prevUrl: '/',
        keyName: 'userName'
      },
      overlap: '',
      underAgeChecked: false,
      overAgeChecked: false,
      buttonUp: false,
      setCount: false
    }
  },
  created () {
    if (this.getReferrer.includes('formData') !== true) {
      this.SET_POPUP(true)
      this.popupSet.content = '잘못된 접근입니다.'
      this.popupSet.count = 'another'
      this.popupSet.nextLink = '/'
      this.popupSet.closeType = 'action'
      this.popupSet.closeLink = '/'
    }
    if (history.pushState !== undefined) {
      history.pushState({}, '', location.href)
      window.onpopstate = () => {
        this.callPrev()
      }
    }
    this.fetchData()
  },
  computed: {
    ...mapGetters([
      'GET_USERNAME'
    ]),
    ...mapState([
      'checkPopup'
    ]),
    ...mapGetters('referrer', [
      'getReferrer'
    ])
  },
  components: {
    AppHeader,
    TrackingProgress,
    AddPopup
  },
  methods: {
    ...mapMutations('referrer', [
      'SET_REFERRER'
    ]),
    ...mapMutations([
      'SET_POPUP'
    ]),
    callPrev () {
      if (this.setCount) {
        this.$router.push('/')
      } else {
        history.go(1)
      }
      this.setCount = true
      // 클로즈 함수 구현
    },
    fetchData () {
      this.overlap = sessionStorage.getItem('joinName')
    },
    nextMain () {
      this.$router.push('/login')
      sessionStorage.removeItem('joinName')
    }
  },
  beforeDestroy () {
    this.setCount = false
    this.SET_POPUP(false)
    this.SET_REFERRER('')
  }
}
</script>

<style lang="scss" scoped>
</style>
